'use strict';
const angular = require('angular');

require('moment');

const uiRouter = require('angular-ui-router');

import routes from './calendar-edit.routes';

export class CalendarEditComponent {
  /*@ngInject*/
  constructor(Auth, $timeout, $stateParams, $state, dialogs, $uibModal, StorageService, CalendarEventService,
              Upload, $q, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.CalendarService = CalendarEventService;
    this.StorageService = StorageService;
    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h3","h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["html"],
      ["archiveImageLink", "insertImage","insertLink"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

    this.cloneId = $stateParams.cloneId;

    this.isGroup = this.isGroup === 'true';
    this.group = $stateParams.group;

    var generalConfig = Config.getModuleConfig(Config.Modules.General);
    var calendarConfig = Config.getModuleConfig(Config.Modules.Calendar);

    this.types = [];

    if (this.isGroup) {
      let groups = calendarConfig.getCalendarGroup();
      // system event lists (e.g. florida-holidays) start with @, events from a master site with "master:"
      this.types = groups[this.group].filter(type => !type.startsWith("@") && !type.startsWith("master:"));
    }

    this.clientLocation = generalConfig.getClientLocation();

    this.timezone = generalConfig.getClientTimezone();
    this.$timeout = $timeout;
    this.eventId = $stateParams.id;
    this.eventType = $stateParams.type;

    let title = this.group ? this.group : this.eventType;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, title + " Event Edit");

    this.$state = $state;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.Upload = Upload;
    this.$q = $q;

    this.dayOfWeek = [false, false, false, false, false, false, false];   // 0=Sun, 1=Mon ... 6=Sat

    this.eventTemplate = {
      title: '',
      description: '',
      start: new Date(),
      end: '',
      allDay: false,
      type: this.eventType,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.event = angular.copy(this.eventTemplate);
    this.assets = [];

    if (this.eventId || this.cloneId) {

      let ID = this.eventId ? this.eventId : this.cloneId;

      this.CalendarService.get({id: ID}, data => {
        this.event = data;
        this.assets = data.attachments;

        this.event.start = this.applyTimezoneChanges(this.event.start, 'subtract');

        if (this.event.end) {
          this.event.end = this.applyTimezoneChanges(this.event.end, 'subtract');
        }

        if (data.location) {
          this.createMarker(data.location);
          this.map.panTo(new google.maps.LatLng(data.location.lat, data.location.lng));
        }

        this.activeTab = (this.event.isRecurring) ? 1 : 0;

        if (this.event.isRecurring) {
          this.event.recurrence.dayOfWeek.forEach(dow => {
            this.dayOfWeek[dow] = true;
          });
          this.repeatUntil = this.event.recurrence.until;
        }

        // Remove iD for clone
        if (this.cloneId)
          delete this.event._id;

      }, err => {
        console.log('Could not load calendar event from server');
      })
    }

    this.mapOptions = {
      zoom: 15,
      center: new google.maps.LatLng(this.clientLocation.lat, this.clientLocation.lng),
      mapTypeId: google.maps.MapTypeId.TERRAIN
    };

    this.map = new google.maps.Map(document.getElementById('map'), this.mapOptions);
    this.marker = null;

    this.infoWindow = new google.maps.InfoWindow();

    var that = this;

    //init autocomplete
    var input = document.getElementById('pac-input');
    if (this.map && this.map.controls && this.map.controls[google.maps.ControlPosition.TOP_LEFT]) {
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
      this.autocomplete = new google.maps.places.Autocomplete(input);
      //autocomplete.bindTo('bounds', $scope.map);
      this.autocomplete.addListener('place_changed', function () {
        that.$timeout(()=>{
          that.event.location = that.setPlace();
        },0);
      });
    }

    var that = this;

    this.dropHandler = function( file, insertAction ) {

        var isImage = that.isImageMime(file.type);
        var isPdf = that.isPdfMime(file.type);

        // validation
        if( !isImage && !isPdf) {
            // ignore other file than images and pdfs
            return;
        }

      /* could check for file size: if( file.size > 500000 ) */

        var defer = that.$q.defer();

        that.Upload.upload({
            url: '/api/storage',
            data: {
                name: file.name,
                file: file,
                storageStrategy: 'local',
                isPublic: true,
                creationUser: that.Auth.getCurrentUserSync()._id,
                active: true
            }
        }).then((response) => {

            if (isImage) {
                insertAction( "insertImage", "/api/storage/" + response.data, true );
                defer.resolve(true);
            } else if (isPdf) {
                that.StorageService.getMeta({id: response.data}, data => {
                    that.assets.push(data);
                    defer.resolve(true);
                }, err => {
                    console.log('could not retrieved storage from server');
                    defer.reject();
                });
            }

        }, (response) => {
            if (response.status > 0) {
                alert(response.status + ': ' + response.data);
                defer.reject();
            }
        });

        return defer.promise;

    };
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  removeAsset(idx) {
    this.assets.splice(idx,1);
  }

  removeLocation() {
    if (this.marker != null) {
      this.marker.setMap(null);
      this.marker = null;
    }

    this.event.location = {};
  }

  setPlace () {
    //infoWindow.close();
    var place = this.autocomplete.getPlace();
    if (!place.geometry) {
      console.log("Autocomplete's returned place contains no geometry");
      return;
    }

    var placeData = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng(), address: place.formatted_address };

    // If the place has a geometry, then present it on a map.
    if (place.geometry.viewport) {
      this.map.fitBounds(place.geometry.viewport);
    } else {
      this.map.setCenter(place.geometry.location);
    }

    this.createMarker(placeData);

    return placeData;
  };

  createMarker(info) {
    var marker = new google.maps.Marker({
      map: this.map,
      position: new google.maps.LatLng(info.lat, info.lng),
      title: info.address
    });
    marker.content = '<div class="infoWindowContent">' + info.address + '</div>';

    var that = this;

    google.maps.event.addListener(marker, 'click', function () {
      that.infoWindow.setContent('<h4>' + marker.title + '</h4>' + marker.content);
      that.infoWindow.open(this.map, marker);
    });

    if (this.marker != null) {
      this.marker.setMap(null);
      this.marker = null;
    }

    this.marker = marker;
  };


  openInfoWindow(e, selectedMarker) {
    e.preventDefault();
    google.maps.event.trigger(selectedMarker, 'click');
  }

  checkStartDate = function(data) {
    if (this.event.end && (new Date(data) > new Date(this.event.end))) {
      return "The start date must not be after the end date";
    }
  };

  checkEndDate = function(data) {
    if (new Date(data) < new Date(this.event.start)) {
      return "The end date, if given, must not be before the start date";
    }
  };

  checkRepeatUntilDate = function(data) {
    if (new Date(data) < new Date(this.event.start)) {
      return "The end date of recurrence must not be before the start date";
    }
  };

  getTimezoneDifference(targetTimezone, userTimezone) {
    var now = moment();

    if (typeof userTimezone != 'undefined') {
      now = moment.tz(userTimezone);
    }

    var localOffset = now.utcOffset();

    now.tz(targetTimezone);

    var centralOffset = now.utcOffset();
    var diffInMinutes = localOffset - centralOffset;

    return diffInMinutes;
  }

  applyTimezoneChanges(datetime, operation) {
    return moment.utc(datetime)[operation](this.getTimezoneDifference(this.timezone),'minutes').format();
  }

  setRecurrenceState(isRecurring) {
    this.event.isRecurring = isRecurring;

    var allEmpty = function(dow) {
      var atLeastOneTrue = false;

      dow.forEach(day => {
        if (day)
          atLeastOneTrue = true;
      });

      return !atLeastOneTrue;
    };

    if (isRecurring && allEmpty(this.dayOfWeek) && this.event.start) {
      var dow = moment(this.event.start).day();

      this.dayOfWeek[dow] = true;
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    if (this.event.isRecurring && !this.repeatUntil)
      return;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        this.event = angular.copy(this.eventTemplate);
        this.submitted = false;

        var actionString = (this.eventId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "Your calendar event has been "+actionString+" successfully");
        dlg.result.then(() => {
          if (that.isGroup) {
            that.$state.go("calendar-"+this.group+"-group");
          } else {
            that.$state.go("calendar-"+this.eventType+"-list");
          }
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.event.attachments = this.assets.map(asset => {
        return asset._id;
      });

      this.event.start = this.applyTimezoneChanges(this.event.start, 'add');

      if (this.event.end) {
        this.event.end = this.applyTimezoneChanges(this.event.end, 'add');
      }

      if (this.event.isRecurring) {
        if (this.event.recurrence)
          this.recurrenceAlreadyExists = true;

        this.event.recurrence = {
          until: this.repeatUntil,
          dayOfWeek: []
        };

        for (var dow=0; dow <= 6; dow++) {
          if (this.dayOfWeek[dow])
            this.event.recurrence.dayOfWeek.push(dow);
        }
      } else {
        if (this.event.recurrence) {
          this.event.recurrence = {};
          this.recurrenceHasBeenRemoved = true;
        }
      }

      if (this.eventId) {  // Save changes on the current calendar event
        this.CalendarService.update({id: this.eventId}, this.event, onSuccess, onError);
      } else { // Create a new calendar event
        this.CalendarService.save(this.event, onSuccess, onError);
      }
    }
  }

  openAssetBrowserModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToUserAssets: !that.Auth.isAdminSync(),
            userId: that.Auth.getCurrentUserSync()._id,
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        that.assets = that.assets.concat(newlySelectedAssets);
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.assets.push(data);
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduuApp.calendarEdit', [uiRouter])
  .config(routes)
  .component('calendarEdit', {
    template: require('./calendar-edit.html'),
    controller: CalendarEditComponent,
    controllerAs: 'ctrl',
    bindings: {
      isGroup: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/calendar/edit/calendar-edit.component.js